import { useEffect } from 'react';
import { BgImage } from '@flyer/components/next';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { useAuth } from '@/providers/auth';
import btnBack from '@/components/auth/assets/btn_back.png';
import background from './bg.png';

/** Layout for guest: login, register, forgot password */
export default function AuthLayout({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (user && typeof router.query.auth_redirect_url !== 'string') {
      // keep query when push
      void router.push({
        pathname: '/',
        query: { ...router.query },
      });
    }
  }, [router, user]);

  return (
    <BgImage
      alt="Flyer testing platform"
      src={background}
      imageClassName="w-full h-full object-cover"
      wrapClassName="fixed inset-0 w-full h-full"
      className="overflow-x-hidden overflow-y-auto flex flex-col items-center justify-center"
    >
      <div className="fixed left-0 top-[5vh] xl:top-[10vh]">
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <div
          className="w-[50px] h-[40px] xl:w-[80px] xl:h-[70px] hover:cursor-pointer hover:opacity-80"
          onClick={() => router.back()}
        >
          <Image alt="part" src={btnBack} className="w-full" />
        </div>
      </div>
      <div className="flex flex-col lg:flex-row gap-5 items-center justify-center lg:w-[70rem] m-auto xl:w-[80rem] 2xl:w-[90rem] w-full p-2">
        <div className="flex flex-col gap-8 text-center sm:w-[70%] lg:w-[50%] xl:w-[45%] 2xl:w-[35%] w-[95%]">
          {children}
        </div>
      </div>
    </BgImage>
  );
}
